import React from 'react';
import CountOfTotal from '../../../../../components/CountOfTotal';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import Modal from '../../../../../components/Modal';
import InfoForm from '../../../../../components/outline/InfoForm';
import { MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT } from '../../../../../constants/service/app/tagConstants';
import './EditTabTrendKeywordModal.scss';

const EditTabTrendKeywordModal = (props) => {
  const { form, isOpen, closeModal, memo, onSubmit, setData } = props;

  return (
    <Modal
      title="태그 트렌드 키워드 편집하기"
      isOpen={isOpen}
      width={560}
      height={600}
      isFooter={true}
      okText="저장"
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <InfoForm className="edit-tag-trend-key-modal-wrap">
        {/*추천 태그 리스트 메모*/}
        <TextAreaForm
          form={form}
          label={
            <span>
              추천 태그 리스트 메모
              <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT} />
            </span>
          }
          maxLength={MAXIMUM_NUMBER_OF_RECOMMEND_TAG_MEMO_TEXT}
          onChange={(value) =>
            setData({
              name: 'memo',
              value,
            })
          }
          initialValue={memo}
          subContent={'* 추천 태그 리스트 저장 시 남길 메모를 입력해주세요.'}
          name="memo"
          autoSize={{ minRows: 6, maxRows: 50 }}
        />
      </InfoForm>
    </Modal>
  );
};

export default EditTabTrendKeywordModal;
